import { render, staticRenderFns } from "./InterfaceLanguageDropdown.vue?vue&type=template&id=4eb29aa2&"
import script from "./InterfaceLanguageDropdown.vue?vue&type=script&lang=ts&"
export * from "./InterfaceLanguageDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./InterfaceLanguageDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports